<div class="flex flex-col">
    <section>
         <!-- ## SERVICES ## -->
         <h1 class="font-extrabold text-2xl md:mx-4 text-primary max-sm:px-4" *ngIf="serviceList.length >= 1">Current services:</h1>
         <fuse-card class="flex flex-col text-left  md:w-full mx-4 p-8 shadow-lg drop-shadow mt-8"
         *ngFor="let service of serviceList">
         <div class="flex flex-row justify-end text-end items-end mb-6">
            <p class="rounded-2xl p-2 font-bold max-sm:text-md"
                [ngClass]="getServiceStatus(service.ServiceAccountStatus)?.color">
                {{getServiceStatus(service.ServiceAccountStatus)?.label}}</p>
        </div>
         <fuse-card class="rounded-md mb-8 drop-shadow-sm" *ngIf="service?.LeadActionTypeCode == 'ServiceCancellation' || service?.LeadActionTypeCode == 'ServiceUpgrade' || service?.LeadActionTypeCode == 'ServiceDowngrade'">
             <div class="flex-row flex p-2 bg-white-100 w-full text-center items-center">
                 <div class="pt-1">
                     <mat-icon class="text-red-500">error</mat-icon>
                 </div>
                 <div class="ml-4">
                     <h1 class="font-bold md:text-lg">
                         <ng-container [ngSwitch]="service?.LeadActionTypeCode" class="text-black">
                             <span *ngSwitchCase="'ServiceCancellation'">This service is scheduled to be cancelled</span>
                             <span *ngSwitchCase="'ServiceUpgrade'">This service is scheduled to be upgraded</span>
                             <span *ngSwitchCase="'ServiceDowngrade'">This service is scheduled to be downgraded</span>
                         </ng-container>
                     </h1>
                 </div>
             </div>
         </fuse-card>
         <div class="flex md:flex-row w-full flex-col">
             <div class="w-full">
                 <img class='p-4'
                     loading="lazy"
                     [src]="service?.routerImage"
                     alt="router image">
             </div>
             <div class="flex flex-col w-full">
                 <div class="flex flex-col items-center">
                     <h1 class="text-2xl font-black max-sm:mt-8 max-sm:text-lg">{{service?.PackageName}} from
                         {{service?.SupplierName}}</h1>
                 </div>
                 <div class="flex flex-row w-full mt-8 justify-between">
                     <div class="flex flex-row">
                         <div>
                             <mat-icon class="m-2">arrow_downward</mat-icon>
                         </div>
                         <div class="flex flex-col">
                             <p class="font-bold">Download</p>
                             <p>{{service?.MbpsDownload}}Mbps</p>
                         </div>
                     </div>
                     <div class="flex flex-row">
                         <div>
                             <mat-icon class="m-2">arrow_upward</mat-icon>
                         </div>
                         <div class="flex flex-col">
                             <p class="font-bold">Upload</p>
                             <p>{{service?.MbpsUpload}}Mbps</p>
                         </div>
                     </div>
                 </div>
                 <div class="mt-4 text-center items-center">
                     <p class="text-lg mt-4 font-medium">
                         {{service?.Description}}
                     </p>
                 </div>
             </div>
         </div>
         <hr>
         <div class="flex md:flex-row flex-col w-full items-center">
             <button *ngIf="!service.upDownCancel" class="mt-2 text-lg font-bold mx-4 bg-accent max-sm:w-full" mat-flat-button
                 [matMenuTriggerFor]="menu">
                 <span >Manage</span>
             </button>
             <mat-menu #menu="matMenu" class="pb-0 rounded-md">
                 <button mat-menu-item>
                     <p class="font-medium" (click)="viewUsage(service)">View Usage</p>
                 </button>
                 <button mat-menu-item>
                     <p class="font-medium" (click)="logIssue(service, 'issue')">Log an Issue</p>
                 </button>
                 <button mat-menu-item (click)="logIssue(service, 'relocate')" *ngIf="service.SubServiceTypeCode != 'Service:Internet:MobileBroadband'">
                     <p class="font-medium">Relocate Service</p>
                 </button>
                 <button mat-menu-item (click)="purchaseAddOn(service)"
                     *ngIf="service?.LeadActionTypeCode != 'ServiceCancellation' && service.SubServiceTypeCode != 'Service:Internet:FibreFTTH'">
                     <p class="font-bold">Purchase Add-On</p>
                 </button>
                 <button mat-menu-item (click)="cancelPackage(service)"
                     *ngIf="service?.LeadActionTypeCode != 'ServiceCancellation'">
                     <p class="font-bold">Cancel Package</p>
                 </button>
                 <button mat-menu-item (click)="downgradePackage(service)"
                    *ngIf="service?.LeadActionTypeCode != 'ServiceDowngrade'">
                     <p class="font-bold">Downgrade Package</p>
                 </button>
                 <button mat-menu-item (click)="upgradePackage(service)" class='bg-primary-500 opacity-90'
                  *ngIf="service?.LeadActionTypeCode != 'ServiceUpgrade'">
                     <p class="font-bold text-white">Upgrade Package</p>
                 </button>
                 <!-- Add more menu items as needed -->
             </mat-menu>

            <div class="flex flex-col justify-start" >
                <button *ngIf="service?.LeadActionTypeCode == 'ServiceCancellation' || service?.LeadActionTypeCode == 'ServiceUpgrade' || service?.LeadActionTypeCode == 'ServiceDowngrade'" class="text-lg font-bold bg-primary-200 mb-4 md:w-1/3" mat-flat-button [disabled]="loading"
                    (click)="undoCancellation(service)">
                    <p *ngIf="!loading">Undo {{addSpace(service?.LeadActionTypeCode)}}</p>
                    <mat-progress-spinner
                        *ngIf="loading"
                        [diameter]="24"
                        [mode]="'indeterminate'"></mat-progress-spinner>
                </button>
   
                <p *ngIf="service.upDownCancel">
                   A change of service was logged with our team. Please scroll down and see <b>{{service.linkedLead}}</b> under orders in progress, as the order might require action on your part to complete the process.
                   Please also note, depending on the terms of service, this action might time some time to complete.
                </p>
            </div>
         </div>
        <hr>
        <div *ngIf="addonList.length >= 1">
            <div *ngFor="let a of addonList">
                <div *ngIf="a.AddOnForAccountOfferableID == service.EntityAccountOfferableEntityID && a.Billing_IsActive ">
                    <div class="flex flex-col md:flex-row mt-4 items-center sm:mb-2 justify-between">
                        <div class="flex flex-col">
                            <h1 class="text-lg font-black max-sm:text-lg">{{a?.ProductName}}</h1>
                        </div>
                        <div class="flex flex-col">
                            <h1 class="font-black">{{a?.PriceIncl | currency:'R'}}</h1>
                        </div>
                        <div>
                            <button class="font-bold mx-2 bg-primary text-white max-sm:w-full" mat-flat-button (click)="cancelPackage(a)">
                                <span>Cancel Add-On</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     </fuse-card>
    </section>
    
</div>